"use client";

import dynamic from "next/dynamic";
import { Skeleton } from "@/components/atoms/skelton";

// Lazy load SearchAvailableRoomForm - contains heavy deps: react-hook-form, react-day-picker, react-select, valibot
const SearchAvailableRoomForm = dynamic(
  () =>
    import("./SearchAvailableRoomForm").then((mod) => ({
      default: mod.SearchAvailableRoomForm,
    })),
  {
    ssr: false,
    loading: () => (
      <div className="hidden w-full max-w-[980px] md:block">
        <div className="flex items-center gap-4 rounded-xl bg-white p-4 shadow-lg">
          <Skeleton className="h-14 flex-1 rounded-lg" />
          <Skeleton className="h-14 w-[200px] rounded-lg" />
          <Skeleton className="h-14 w-[140px] rounded-lg" />
          <Skeleton className="h-14 w-[100px] rounded-lg" />
          <Skeleton className="h-14 w-[120px] rounded-lg" />
        </div>
      </div>
    ),
  }
);

export { SearchAvailableRoomForm as LazySearchAvailableRoomForm };
